import { apiRequest } from '@/calls/helpers';

const sendNewPassword = async (data, locale) => apiRequest(`session/account_password_forget?lang=${locale}`, {
  method: 'POST',
  body: data
});

export {
  // eslint-disable-next-line import/prefer-default-export
  sendNewPassword
};
